import React, { useContext } from 'react';

import { isNil } from 'ramda';
import { useHistory } from 'react-router';
import { useNetworkState } from 'react-use';

import { FlightsContextProvider } from 'components/Pages/Admin/GuestPortal/Flights/context';
import { FlightsTable } from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable';
import { tableWrapperLanding } from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable/index.module.css';
import { useFlights } from 'components/Pages/Admin/GuestPortal/Flights/useFlights';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { isInternalItem } from 'store/itinerariesItem';
import { confirmAlert } from 'utils/alert';
import { getDateFormat } from 'utils/date';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { GUEST_PORTAL_STEPS } from 'utils/itineraries/guestPortal/map';
import { realocationsHeaderId } from 'utils/itineraries/guestPortal/prepareGuestPortal';

import { SaveIndicator } from '../shared/SaveIndicator';
import { Head } from './Head';
import { NotifyAgent } from './NotifyAgent';
import { useActions } from './useActions';

export function Flights() {
  const history = useHistory();
  const itinerariesItemContext = useItinerariesItemContext();
  const isInsideItinerariesItemBuilder = !isNil(itinerariesItemContext);
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.GUEST_PORTAL);
  const { readOnly, landingTheme, isSamplePreview, page } = useContext(LandingPageContext);
  const {
    createRelocation,
    handleChangeRelocation,
    deleteRelocation,
    handleSendNotify,
    isSendingNotify,
    appHasChanges,
    handleBlurRelocation,
    handleEditRelocation,
  } = useActions();
  const context = useFlights({
    items: page.relocations,
    onSave: createRelocation,
    onItemChange: handleChangeRelocation,
    onItemRemove: deleteRelocation,
    checkPolicy: !isInsideItinerariesItemBuilder,
    onItemBlur: handleBlurRelocation,
    onEdit: handleEditRelocation,
    dateFormat: getDateFormat(page?.settings?.displayDatesDdMmYyyy),
  });
  const { online } = useNetworkState();
  const { items } = context;

  const handleDisableClick = () => {
    if (readOnly || !isInsideItinerariesItemBuilder) return;

    confirmAlert({
      title: (
        <>
          Edits to this page can only be done in the Flights Tab. <br /> Do you want to go there now?
        </>
      ),
      confirmButtonText: 'Go to Flights Tab',
      onConfirm: () => {
        history.push(getStepPath(GUEST_PORTAL_STEPS.RELOCATIONS, itinerariesItemContext.itemId, undefined));
      },
    });
  };

  return (
    <>
      <Head />

      <div>
        {!isInsideItinerariesItemBuilder && (
          <SaveIndicator appHasChanges={appHasChanges} mountId={realocationsHeaderId} />
        )}

        <FlightsContextProvider data={context}>
          <FlightsTable
            disabled={isSamplePreview}
            onDisableClick={handleDisableClick}
            isReadonly={isInsideItinerariesItemBuilder}
            items={items.filter((item) => item.id && !isInternalItem(item))}
            withoutMenu
            showSecondButton={!isInsideItinerariesItemBuilder}
            wrapperClassName={tableWrapperLanding}
            landingTheme={landingTheme}
            dateFormat={getDateFormat(page?.settings?.displayDatesDdMmYyyy)}
          />
        </FlightsContextProvider>

        {!isInsideItinerariesItemBuilder && !isSamplePreview && online && (
          <NotifyAgent
            disabled={isSendingNotify || isSamplePreview}
            onSendNoti={handleSendNotify}
            isSendingNotify={isSendingNotify}
          />
        )}
      </div>
    </>
  );
}
